<template>
  <div class="color-picker">
    <color-picker
      class="window"
      v-model="color"
      :disableAlpha="true"
      :presetColors="presetColors"
    />
  </div>
</template>

<script>
import { Sketch } from 'vue-color'
import ColorPickerBase from '@/components/Content/Palette/CommonLayouts/Base/ColorpickerBase'

export default {
  mixins: [
    ColorPickerBase
  ],
  components: {
    'ColorPicker': Sketch
  },
  data () {
    return {
      color: { hex: this.selectColor },
      presetColors: [],
    }
  },
  props: [
    'selectColor',
    'transparent',
  ],
  methods: {
    initPresetColors () {
      this.presetColors = this.transparent ? this.defaultColors : this.borderColors
    }
  },
  watch: {
    'color.hex' (value) {
      this.$emit('updateStyles', value)
    },
    'color.hex8' (value) {
      // 透明が選択された場合、色を空欄にする
      if (value === '#00000000') {
        this.color = { hex: null }
      }
    },
    transparent () {
      this.initPresetColors()
    }
  },
  beforeMount () {
    this.initPresetColors()
  }
}
</script>

<style scoped>
.window {
  position: absolute;
  z-index: 2;
}
</style>
